import { Icon } from "@mui/material";
import React from "react";

const IconHolder = ({ iconName, iconColor }) => {
  return <Icon className={"flagColor_" + iconColor}>{iconName}</Icon>;
};

export default IconHolder;
